import { create } from 'zustand'

interface LoginSelfService {
    page: 'cpf' | 'cip'
    setPage: (value: 'cpf' | 'cip') => void
}

export const useLoginSelfService = create<LoginSelfService>()(set => ({
    page: 'cpf',
    setPage: page => set({ page }),
}))
